export default __webpack_public_path__ + "static/media/person-icon-1682.18edf212.png";